import { gql } from "@apollo/client";

export const USER_MANAGEMENT_CHECK = gql`
  query UserManagementCheck(
    $email: String!
    $username: String!
    $password: String
    $action: String!
  ) {
    checkUserValidity(
      email: $email
      username: $username
      password: $password
      action: $action
    )
  }
`;

export const CHECK_USED_EMAIL = gql`
  mutation ($email: String!) {
    checkAlreadyUsedEmail(email: $email)
  }
`;

export const CHECK_PASSWORD_EXPIRED = gql`
  query GetPasswordExpiration($email: String!) {
    userDetails(filters: { email: { eq: $email } }) {
      data {
        attributes {
          password_expiration
        }
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($identifier: String!, $password: String!) {
    login(input: { identifier: $identifier, password: $password }) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      ok
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword(
    $code: String!
    $password: String!
    $passwordConfirm: String!
  ) {
    resetPassword(
      code: $code
      password: $password
      passwordConfirmation: $passwordConfirm
    ) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`;

export const GET_USER_PAGE_PERMISSIONS = gql`
  query GetUserDetails($id: ID!) {
    userDetails(filters: { users_permissions_user: { id: { eq: $id } } }) {
      data {
        attributes {
          page_permissions {
            job_list
            reporting
            weightron
            invoices
            audit
            documents
          }
        }
      }
    }
  }
`;
